import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Observable, finalize, map, take } from "rxjs";
import {
	Actions,
	Intents,
	Menu,
	Message,
	Bots,
	Catalogs,
	Templates,
	Labels,
	Orders,
	Widgets,
	Products,
	Options,
	Variants,
	Facets,
	Categories,
	users,
	DraftOrders
} from "src/app/features/models/list.model";
import { ToolsService } from "./tools.service";
import { WhereFilterOp } from '@firebase/firestore-types';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { getFunctions, httpsCallable, httpsCallableFromURL } from "firebase/functions";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { LoggingService } from "./Logging.service";

interface Condition {
	left: any;
	operator: any;
	right: any;
}

@Injectable()
export class DataAccessService {
	urlUpload: any;
	getThemeID(themeID: any) {
		throw new Error('Method not implemented.');
	}

	docid!: string;
	idParent!: string;
	idaction!: string;


	constructor(private loggingService: LoggingService,private afs: AngularFirestore, private tools: ToolsService,
		public snackBar: MatSnackBar, private storage: AngularFireStorage
	) { }

	testData$() {
		return this.afs.collection<any>('test-coll').valueChanges();
	}
	getWidgetsNonDefault(collection, idBOT): Observable<Widgets[]> {
		return this.getCollectionWhere([`${collection}/${idBOT}/widgets/`], [{
			left: 'show',
			operator: '==',
			right: true
		}]);
	}
	getDocument(docPath: string) {
		return this.afs.doc(docPath).snapshotChanges().pipe(
			map(
				a => {
					const data = a.payload.data() as any;
					const id = a.payload.id;
					const path = a.payload.ref.path;
					return {
						id,
						path,
						...data
					}; // => flattened data : {a:1
				}));
	}
	getDocumentWithoutRealTime(docPath: string) {
		return this.afs.doc(docPath).get().pipe(
			map(
				a => {
					const data = a.data() as any;
					const id = a.id;
					const path = a.ref.path;
					return {
						id,
						path,
						...data
					};
				}),
			take(1) // Cette ligne assure que la fonction s'exécute une seule fois
		);
	}
	
	getCollectionWhere(pathArray: string[], conditions: Condition[]): Observable<any[]> {
		const coPath = pathArray.join('/');
		return this.afs.collection<any>(coPath,
			ref => {
				const cnd0 = conditions.pop();
				if (!this.tools.isUndefined(cnd0)) {
					let query = ref.where(cnd0?.left, cnd0?.operator, cnd0?.right).orderBy('timeStamp', 'desc');
					conditions.map(({
						left,
						operator,
						right
					}: Condition) => {
						query = query.where(left, operator, right);
					});
					return query;
				} else {
					return ref;
				}
			}).snapshotChanges().pipe(
				map(actions => {

					return actions.map(a => {
						const data = a.payload.doc.data() as any;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					});
				}));
	}

	getCollectionWhereWithoutTime(pathArray: string[], conditions: Condition[]): Observable<any[]> {
		const coPath = pathArray.join('/');
		return this.afs.collection<any>(coPath,
			ref => {
				const cnd0 = conditions.pop();
				if (!this.tools.isUndefined(cnd0)) {
					let query = ref.where(cnd0?.left, cnd0?.operator, cnd0?.right);
					conditions.map(({
						left,
						operator,
						right
					}: Condition) => {
						query = query.where(left, operator, right);
					});
					return query;
				} else {
					return ref;
				}
			}).snapshotChanges().pipe(
				map(actions => {
					return actions.map(a => {
						const data = a.payload.doc.data() as any;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					});
				}));
	}

	getBotsforAnalytics(pathArray: string[], conditions: Condition[]): Observable<any[]> {
		const coPath = pathArray.join('/');
		return this.afs.collection<any>(coPath,
			ref => {
				const cnd0 = conditions.pop();
				if (!this.tools.isUndefined(cnd0)) {
					let query = ref.where(cnd0?.left, cnd0?.operator, cnd0?.right);
					conditions.map(({
						left,
						operator,
						right
					}: Condition) => {
						query = query.where(left, operator, right);
					});
					return query;
				} else {
					return ref;
				}
			}).snapshotChanges().pipe(
				map(actions => {
					return actions.map(a => {
						const data = a.payload.doc.data() as any;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						this.loggingService.log("path", `${path}/appData/`)
						return this.afs.collection<any>(`${path}/appData/`)
							.snapshotChanges()
							.pipe(
								map(actions => {
									return actions.map(a => {

										const data = a.payload.doc.data() as any;


										const id = a.payload.doc.id;

										const path = a.payload.doc.ref.path;
										return {
											id,
											path,
											...data
										};
									})
								})
							);
					});
				}));
	}

	getCollectionWhereWithalphabeticalOrder(pathArray: string[], conditions: Condition[]): Observable<any[]> {
		const coPath = pathArray.join('/');
		return this.afs.collection<any>(coPath,
			ref => {
				const cnd0 = conditions.pop();
				if (!this.tools.isUndefined(cnd0)) {
					let query = ref.where(cnd0?.left, cnd0?.operator, cnd0?.right)
					conditions.map(({
						left,
						operator,
						right
					}: Condition) => {
						query = query.where(left, operator, right);
					});
					return query;
				} else {
					return ref;
				}
			}).snapshotChanges().pipe(
				map(actions => {
					return actions.map(a => {
						const data = a.payload.doc.data() as any;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					});
				}));
	}

	//new
	deleteDocumentCollectionWithSubCollection(user: any, path: string) {
		const callable = firebase.functions().httpsCallable('mintAdminToken');
		const obs = callable({
			uid: user.id
		});
		obs.then(async (res: any) => {
			firebase.auth().signInWithCustomToken(res.token).then(function (connect) {
				var deleteFn = firebase.functions().httpsCallable('recursiveDelete');
				deleteFn({ path: path })
					.then(function (result) {
						//	this.snackBar.open('Bot deleted', '', {duration: 4000});
					})
					.catch(function (err) {
						//this.snackBar.open('error', '', {duration: 4000});
					});
			})
		})


	}
	// to remoove 
	getbot(idBot: string): Observable<any[]> {

		return this.afs.collection<any>(`bots`)
			.snapshotChanges()
			.pipe(
				map(actions => {

					return actions.map(a => {

						const data = a.payload.doc.data() as any;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					}).find(x => x.id == idBot)
				})
			);
	}
	// to remoove 
	getTheme(idTheme: string): Observable<any[]> {

		return this.afs.collection<any>(`themes`)
			.snapshotChanges()
			.pipe(
				map(actions => {

					return actions.map(a => {

						const data = a.payload.doc.data() as any;
						const id = a.payload.doc.id;

						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					}).find(x => x.id == idTheme)
				})
			);
	}


	/* ------------------------Actions------------------------ */
	addAction(collection: any, idBot: string, actID: string, actionName: string, builtIn: boolean, event: any, intention: any, show: boolean, builtTemplate: boolean, elements: any): Promise<any> {
		const actionRef = this.afs.collection(`${collection}/${idBot}/actions/`).doc(actID)
		return actionRef.set({
			"name": actionName,
			"show": show,
			builtTemplate: builtTemplate,
			built: builtIn,
			event: event,
			intention: intention,
			//rang: rang,
			timeStamp: Date.now()
		})
			.then(
				() => {
					//TODO: add index into element, the order at which this element response will be shown @ bit's responses
					actionRef.collection('elements').add(elements)
				}).catch(
					e => {
						this.loggingService.log(e);
					})
			.then(() => {
				return actionRef.snapshotChanges()
					.pipe(
						map(a => {
							const data = a.payload.data() as Actions;
							const id = a.payload.id;
							const path = a.payload.ref.path;
							return {
								id,
								...data
							};
						}),
					);
			})
	}


	addFollowUp(collection: any, idBot: string, actID: string, actionName: string): Promise<any> {
		const actionRef = this.afs.collection(`${collection}/${idBot}/FollowUpMessages/`).doc(actID)
		return actionRef.set({
			"name": actionName,
			//rang: rang,
			timeStamp: Date.now()
		})
			.then(() => {
				return actionRef.snapshotChanges()
					.pipe(
						map(a => {
							const data = a.payload.data() as Actions;
							const id = a.payload.id;
							const path = a.payload.ref.path;
							return {
								id,
								...data
							};
						}),
					);
			})
	}

	addMarketingMessage(collection: any, idBot: string, actID: string, actionName: string): Promise<any> {
		const actionRef = this.afs.collection(`${collection}/${idBot}/MarketingMessages/`).doc(actID)
		return actionRef.set({
			"name": actionName,
			//rang: rang,
			timeStamp: Date.now()
		})
			.then(() => {
				return actionRef.snapshotChanges()
					.pipe(
						map(a => {
							const data = a.payload.data() as Actions;
							const id = a.payload.id;
							const path = a.payload.ref.path;
							return {
								id,
								...data
							};
						}),
					);
			})
	}

	updateResponseActionElement(docpath: string, element: any): Promise<any> {
		return this.afs.doc(docpath).update(element)
			.then(

				() => {
					// this.snackBar.open('success', '', {
					// 	duration: 4000
					// });
				}
			).catch(
				e => {
					this.loggingService.log(e);
					this.snackBar.open('error', '', {
						duration: 4000
					});
				});
	}

	addResponseActionElement(idBOT: string, actID: string, element: any): Promise<any> {
		return this.afs.collection(`bots/${idBOT}/actions/`).doc(actID).collection('elements').add(element)
			// this.afs.doc(docpath).update(element)
			.then(
				() => {

					this.loggingService.log('success');
					this.snackBar.open('success', '', {
						duration: 4000
					});
				}
			).catch(
				e => {

					this.loggingService.log(e);
					this.snackBar.open('error', '', {
						duration: 4000
					});
				});

	}

	addResponseActionElementDesign(collection: any, idBOT: string, actID: string, element: any): Promise<any> {
		return this.afs.collection(`${collection}/${idBOT}/actions/`).doc(actID).collection('elements').add(element)
			// this.afs.doc(docpath).update(element)
			.then(
				() => {

					this.loggingService.log('success');
					this.snackBar.open('success', '', {
						duration: 4000
					});
				}
			).catch(
				e => {

					this.loggingService.log(e);
					this.snackBar.open('error', '', {
						duration: 4000
					});
				});

	}

	addResponseAction(idBOT: string, recID: string, name: string): Promise<any> {
		return this.afs.collection(`bots/${idBOT}/actions/`).doc(recID).set({
			name: name,
			timeStamp: Date.now()
		}) // this.afs.doc(docpath).update(element)
			.then(
				() => {

					//this.loggingService.log('success');
					// this.snackBar.open('success', '', {
					// 	duration: 4000
					// });
				}
			).catch(
				e => {

					this.loggingService.log(e);
					this.snackBar.open('error', '', {
						duration: 4000
					});
				});
	}

	addResponseActionDefault(idBOT: string, recID: string, name: string, show: boolean): Promise<any> {
		return this.afs.collection(`bots/${idBOT}/actions/`).doc(recID).set({
			name: name,
			show: show,
			timeStamp: Date.now()
		}) // this.afs.doc(docpath).update(element)
			.then(
				() => {

					//this.loggingService.log('success');
					// this.snackBar.open('success', '', {
					// 	duration: 4000
					// });
				}
			).catch(
				e => {

					this.loggingService.log(e);
					this.snackBar.open('error', '', {
						duration: 4000
					});
				});
	}

	addResponseRecElement(idBOT: string, recID: string, name: string, element: any): Promise<any> {
		return this.afs.collection(`bots/${idBOT}/actions/`).doc(recID).set({
			name: name, timeStamp: Date.now(), 'type': recID
		}).then(
			() => {
				//TODO: add index into element, the order at which this element response will be shown @ bit's responses
				this.afs.collection(`bots/${idBOT}/actions/`).doc(recID).collection('elements').add(element)
					.then(

						() => {
							this.loggingService.log('success');
							this.snackBar.open('success', '', {
								duration: 4000
							});
						}
					).catch(
						e => {
							this.loggingService.log(e);
							this.snackBar.open('error', '', {
								duration: 4000
							});
						});
			})
	}

	updateResponseRecElement(docpath: string, actionId: string, idBOT: string, id: string, element: any): Promise<any> {
		return this.afs.collection(`bots/${idBOT}/actions/`).doc(actionId).update({
			"type": id
		}).then(
			() => {
				this.afs.doc(docpath).update(element)
					.then(
						() => {
							this.loggingService.log('success');
							this.snackBar.open('success', '', {
								duration: 4000
							});
						}
					).catch(
						e => {
							this.loggingService.log(e);
							this.snackBar.open('error', '', {
								duration: 4000
							});
						});
			});
	}

	updateRecMessage(user: any, type: any, message: any): Promise<any> {
		return this.afs.collection(`bots/${user.pageID}/templates/`).doc('recommender').set({
			messages: {
				[type]: message
			}
		})

			.catch(
				e => {
					this.loggingService.log(e);
					this.snackBar.open('error', '', {
						duration: 4000
					});
				});
	}

	deleteResponseActionElement(docpath: string): Promise<any> {
		return this.afs.doc(docpath).delete()
			.then(
				() => {

					this.loggingService.log('success');

					this.snackBar.open('success', '', {
						duration: 4000
					});

				}
			).catch(e => {

				this.loggingService.log(e);
				this.snackBar.open('error', '', {
					duration: 4000
				});
			});
	}


	deleteResponseContent(docpath:string)
	{this.afs.doc(docpath).get().subscribe(
		(doc) => {
		  if (doc.exists) {
			const data = doc.data() as Record<string, any>;
			const updates: { [key: string]: any } = {};
	  
			// Iterate over each field and set it to FieldValue.delete()
			Object.keys(data).forEach((key) => {
			  updates[key] = firebase.firestore.FieldValue.delete();
			});
	  
			// Update the document with the deletions
			this.afs.doc(docpath).update(updates).then(() => {
			  this.loggingService.log('Document successfully updated!');
			}).catch((error) => {
			  console.error('Error updating document: ', error);
			});
		  } else {
			this.loggingService.log('No such document!');
		  }
		},
		(error) => {
		  console.error('Error getting document: ', error);
		}
	  );
}
	deleteAction(idBOT: string, docpath: string, actionName: string): Promise<any> {
		return this.afs.doc(docpath).delete()
			.then(
				() => {
					this.afs.collection(`bots/${idBOT}/actions`).doc(`${actionName}`).delete()
						.then(
							() => {
								this.loggingService.log('success');
								this.snackBar.open('success', '', {
									duration: 4000
								});
							}
						).catch(
							e => {
								this.loggingService.log(e);
								this.snackBar.open('error', '', {
									duration: 4000
								});
							});

				});

	}
	// to remoove 
	getActions(idBOT: string): Observable<Actions[]> {

		return this.afs.collection<any>(`bots/${idBOT}/actions`)
			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data() as Actions;
						const docPath  = a.payload.doc.ref.path;
						const id = a.payload.doc.id;
						
						return {
							id,
							docPath,
							...data
						};

					})
				),
			);
	}
	getActionsDesign(collection, idBOT): Observable<Actions[]> {

		return this.afs.collection<any>(`${collection}/${idBOT}/actions`)
			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data() as Actions;

						const id = a.payload.doc.id;
						let path1 = a.payload.doc.ref.path;
						return {
							id,
							path1,
							...data
						};

					})
				),
			);
	}

	getActionsList(idBOT: string): Observable<Actions[]> {
		return this.getCollectionWhere([`bots/${idBOT}/actions`], [{
			left: 'show',
			operator: '==',
			right: true
		},
		{
			left: 'builtTemplate',
			operator: '==',
			right: false
		} 
	]);
	}

	getActionsListDesign(botpath: string): Observable<Actions[]> {
		return this.getCollectionWhere([`${botpath}/actions`], [{
			left: 'show',
			operator: '==',
			right: true
		}]);
	}

	getResponseActionsSpecial(collection: string, idBOT: string): Observable<Actions[]> {
		return this.getCollectionWhereWithalphabeticalOrder([`${collection}/${idBOT}/actions`], [{
			left: 'special',
			operator: '==',
			right: true
		}]);
	}

	getResponseActionsSpecialForBot(collection: string, idBOT: string): Observable<Actions[]> {
		return this.getCollectionWhereWithalphabeticalOrder([`${collection}/${idBOT}/actions`], [{
			left: 'show',
			operator: '==',
			right: true
		}, {
			left: 'special',
			operator: '==',
			right: true
		}]);
	}

	getBuiltActionsList(collection: string, idBOT: string): Observable<Actions[]> {
		return this.getCollectionWhere([`${collection}/${idBOT}/actions`], [{
			left: 'show',
			operator: '==',
			right: true
		}, {
			left: 'built',
			operator: '==',
			right: true
		}]);
	}

	getTemplateActionsList(collection: string, idBOT: string): Observable<Actions[]> {
		return this.getCollectionWhere([`${collection}/${idBOT}/actions`], [{
			left: 'orderStatus',
			operator: '==',
			right: true
		}, {
			left: 'show',
			operator: '==',
			right: false
		}]);
	}

	getOrderActionsList(collection: string, idBOT: string): Observable<Actions[]> {
		return this.getCollectionWhere([`${collection}/${idBOT}/actions`], [{
			left: 'orderStatus',
			operator: '==',
			right: true
		}, {
			left: 'show',
			operator: '==',
			right: false
		}]);
	}

	getEventdActionsList(collection: string, idBOT: string): Observable<Actions[]> {
		return this.getCollectionWhere([`${collection}/${idBOT}/actions`], [{
			left: 'show',
			operator: '==',
			right: false
		}, {
			left: 'event',
			operator: '==',
			right: true
		}]);
	}

	getResponseActionsList(collection: string, idBOT: string): Observable<Actions[]> {
		return this.getCollectionWhere([`${collection}/${idBOT}/actions`], [{
			left: 'show',
			operator: '==',
			right: true
		}, {
			left: 'built',
			operator: '==',
			right: false
		}]);
	}

	getResponseActionsListCondtion(
		collection: string,
		idBOT: string,
		show: boolean,
		built: boolean,
		builtTemplate: boolean,
		event: boolean,
		intention: boolean
	): Observable<Actions[]> {
		this.loggingService.log(collection, idBOT, show, built, builtTemplate, event, intention)
		return this.getCollectionWhere([`${collection}/${idBOT}/actions`], [{
			left: 'show',
			operator: '==',
			right: show
		}, {
			left: 'built',
			operator: '==',
			right: built
		}, {
			left: 'builtTemplate',
			operator: '==',
			right: builtTemplate
		}, {
			left: 'event',
			operator: '==',
			right: event
		}, {
			left: 'intention',
			operator: '==',
			right: intention
		}]);
	}

	getBuildActionsListTemplate(idBOT: string): Observable<Actions[]> {
		return this.getCollectionWhere([`bots/${idBOT}/actions`], [{
			left: 'show',
			operator: '==',
			right: true
		}, {
			left: 'builtTemplate',
			operator: '==',
			right: true
		}]);
	}

	getResponseActionsListTemplate(idBOT: string): Observable<Actions[]> {
		return this.getCollectionWhere([`bots/${idBOT}/actions`], [{
			left: 'show',
			operator: '==',
			right: true
		}, {
			left: 'builtTemplate',
			operator: '==',
			right: false
		}]);
	}

	getResponseActionsListCondtionWithoutTime(
		collection: string,
		idBOT: string,
		show: boolean,
		built: boolean,
		builtTemplate: boolean,
		event: boolean,
		intention: boolean
	): Observable<Actions[]> {
		return this.getCollectionWhereWithoutTime([`${collection}/${idBOT}/actions`], [{
			left: 'show',
			operator: '==',
			right: show
		}, {
			left: 'built',
			operator: '==',
			right: built
		}, {
			left: 'builtTemplate',
			operator: '==',
			right: builtTemplate
		}, {
			left: 'event',
			operator: '==',
			right: event
		}, {
			left: 'intention',
			operator: '==',
			right: intention
		}]);
	}

	getResponseActionsListTemplateDesign(collection: string, idBOT: string): Observable<Actions[]> {
		return this.getCollectionWhereOrderByrang([`${collection}/${idBOT}/actions`], [{
			left: 'show',
			operator: '==',
			right: true
		}, {
			left: 'builtTemplate',
			operator: '==',
			right: true
		}]);
	}

	getAllResponseActionsListTemplateDesign(collection: string, idBOT: string): Observable<Actions[]> {
		return this.getCollectionWhere([`${collection}/${idBOT}/actions`], [{
			left: 'show',
			operator: '==',
			right: true
		}, {
			left: 'builtTemplate',
			operator: '==',
			right: true
		}]);
	}

	getResponseActionsListEventDesign(collection: string, idBOT: string): Observable<Actions[]> {
		return this.getCollectionWhereOrderByrang([`${collection}/${idBOT}/actions`], [{
			left: 'show',
			operator: '==',
			right: true
		}, {
			left: 'builtEvent',
			operator: '==',
			right: true
		}]);
	}

	// to remove
	getIntentData(intent: any): Observable<Intents[]> {
		return this.afs.collection<any>(`${intent.path}`)
			.snapshotChanges()
			.pipe(
				map(intents => {

					return intents.map(a => {

						const data = a.payload.doc.data() as any;

						const id = a.payload.doc.id;

						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					}).sort((a, b) => a.index > b.index ? 1 : -1)
				})
			);
	}

	// to remoove
	getActionElements(action: any): Observable<any[]> {
		return this.afs.collection<any>(`${action.path}/elements`)
			.snapshotChanges()
			.pipe(
				map(actions => {

					return actions.map(a => {

						const data = a.payload.doc.data() as any;

						const id = a.payload.doc.id;

						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					}).sort((a, b) => a.index > b.index ? 1 : -1)
				})
			);
	}

	// to remoove
	getActionElementsForFBGA(action: any, collection: string): Observable<any[]> {
		return this.afs.collection<any>(`${action.path1}/${collection}`)
			.snapshotChanges()
			.pipe(
				map(actions => {

					return actions.map(a => {

						const data = a.payload.doc.data() as any;

						const id = a.payload.doc.id;

						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					}).sort((a, b) => a.index > b.index ? 1 : -1)
				})
			);
	}
	// to remoove 
	getOrders(): Observable<Orders[]> {

		return this.afs.collection<any>(`orders`)
			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data() as Orders;

						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,

							...data
						};

					})
				),
			);
	}
	// to remoove 
	getDraftOrders(): Observable<Orders[]> {

		return this.afs.collection<any>(`draftOrders`)
			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data() as Orders;

						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							...data
						};

					})
				),
			);
	}
	// to remoove 
	getProducts(idCatalog: string): Observable<Products[]> {
		return this.afs.collection<any>(`catalogs/${idCatalog}/products`)
			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data() as Products;

						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							...data
						};
					})
				),
			);
	}

	getVariants(idCatalog: string, idProduct: string): Observable<Variants[]> {
		return this.getCollectionWhereWithoutTime([`catalogs/${idCatalog}/products/${idProduct}/varaints`], [{
			left: 'show',
			operator: '==',
			right: true
		}]);
	}

	getFacets(idCatalog: string, idProduct: string, idVariant: string): Observable<Facets[]> {
		return this.afs.collection<any>(`catalogs/${idCatalog}/products/${idProduct}/varaints/${idVariant}`)
			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data() as Facets;

						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							...data
						};
					})
				),
			);
	}

	updateOrderStatus(docpath: string, status: string): Promise<any> {
		return this.afs.doc(docpath).ref.update({
			status: status
		})
			.then(
				() => {
					this.loggingService.log('success');
				}
			).catch(
				e => {
					this.loggingService.log(e);
				});
	}

	addIntent(idBot: string, intentID: string, IntentName: string): Promise<any> {
		const IntentRef = this.afs.collection(`bots/${idBot}/intents/`).doc(intentID)
		return IntentRef.set({
			name: IntentName,
			type: 'message',
			auto: true,
			show: true,
			built: false,
			timeStamp: Date.now()
		})
			.then(() => {
				return IntentRef.snapshotChanges()
					.pipe(
						map(a => {
							const data = a.payload.data() as Intents;
							const id = a.payload.id;
							const path = a.payload.ref.path;
							return {
								...data
							};
						}),
					);
			});
	}

	addIntentDesign(collection: string, idBot: string, intentID: string, IntentName: string, built: boolean, smallTalk: boolean, show: boolean): Promise<any> {
		const IntentRef = this.afs.collection(`${collection}/${idBot}/intents/`).doc(intentID)
		return IntentRef.set({
			name: IntentName,
			general: true,
			auto: true,
			show: true,
			built: built,
			smallTalk: smallTalk,
			timeStamp: Date.now()
		}, { merge: true })
			.then(() => {
				return IntentRef.snapshotChanges()
					.pipe(
						map(a => {
							const data = a.payload.data() as Intents;
							const id = a.payload.id;
							const path = a.payload.ref.path;
							return {
								...data
							};
						}),
					);
			});
	}

	addBuiltIntentUserSays(collection: string, idBot: string, intentID: string, element: any): Promise<any> {
		const IntentRef = this.afs.collection(`${collection}/${idBot}/intents/`).doc(intentID)
		return IntentRef.set({
			name: element.name,
			built: true,
			dialogFlowAction: element.dialogFlowAction,
			auto: true,
			show: true,
			action: element.action,
			userSays: element.userSays,
			timeStamp: Date.now()
		})
			.then(() => {
				return IntentRef.snapshotChanges()
					.pipe(
						map(a => {
							const data = a.payload.data() as Intents;
							const id = a.payload.id;
							const path = a.payload.ref.path;
							return {
								...data
							};
						}),
					);
			});
	}

	addFallbackIntent(collection: string, idBot: string, intentID: string, element: any): Promise<any> {
		const IntentRef = this.afs.collection(`${collection}/${idBot}/intents/`).doc(intentID)
		return IntentRef.set({
			name: element.name,
			built: false,
			dialogFlowAction: element.dialogFlowAction,
			action: element.action,
			messages: element.messages,
			counter: element.counter,
			timeStamp: Date.now(),
			show: false
		})
			.then(() => {
				return IntentRef.snapshotChanges()
					.pipe(
						map(a => {
							const data = a.payload.data() as Intents;
							const id = a.payload.id;
							const path = a.payload.ref.path;
							return {
								...data
							};
						}),
					);
			});
	}

	createDefaultIntent(idBot: string, intent: any): Promise<any> {
		const intentdef = this.afs.collection(`bots/${idBot}/intents/`).doc(intent.id)
		return intentdef.set(intent)
			.then(() => {
				return intentdef.snapshotChanges()
					.pipe(
						map(a => {
							const data = a.payload.data() as Intents;
							const id = a.payload.id;
							const path = a.payload.ref.path;
							return {
								...data
							};
						}),
					);
			});
	}

	createDefaultIntentId(idBot: string, id: string, intent: any): Promise<any> {
		const intentdef = this.afs.collection(`bots/${idBot}/intents/`).doc(id)
		return intentdef.set(intent)
			.then(() => {
				return intentdef.snapshotChanges()
					.pipe(
						map(a => {
							const data = a.payload.data() as Intents;
							const id = a.payload.id;
							const path = a.payload.ref.path;
							return {
								...data
							};
						}),
					);
			});
	}

	getIntentsShows(idBOT: string): Observable<Intents[]> {
		return this.getCollectionWhere([`bots/${idBOT}/intents`], [{
			left: 'show',
			operator: '==',
			right: true
		}])
	}
	getIntentsShowsDesign(collection: string, idBOT: string): Observable<Intents[]> {
		return this.getCollectionWhere([`${collection}/${idBOT}/intents`], [{
			left: 'show',
			operator: '==',
			right: true
		}]);
	}

	getBuiltIntentsShows(idBOT: string): Observable<Intents[]> {
		return this.getCollectionWhere([`bots/${idBOT}/intents`], [{
			left: 'show',
			operator: '==',
			right: true
		}, {
			left: 'built',
			operator: '==',
			right: true
		}]);
	}

	getBuiltIntentsShowsDesign(collection: string, idBOT: string): Observable<Intents[]> {
		return this.getCollectionWhere([`${collection}/${idBOT}/intents`], [{
			left: 'show',
			operator: '==',
			right: true
		}, {
			left: 'smallTalk',
			operator: '==',
			right: false
		}, {
			left: 'built',
			operator: '==',
			right: true
		}]);
	}

	getGeneralIntentsShowsDesign(collection: string, idBOT: string): Observable<Intents[]> {
		return this.getCollectionWhere([`${collection}/${idBOT}/intents`], [{
			left: 'show',
			operator: '==',
			right: false
		}, {
			left: 'smallTalk',
			operator: '==',
			right: false
		}, {
			left: 'built',
			operator: '==',
			right: false
		}]);
	}

	getGeneralIntentsDesign(collection: string, idBOT: string): Observable<Intents[]> {
		return this.getCollectionWhere([`${collection}/${idBOT}/intents`], [{
			left: 'show',
			operator: '==',
			right: true
		}, {
			left: 'built',
			operator: '==',
			right: true
		}]);
	}

	// Manually
	getBuiltIntentsSpecificShows(idBOT: string): Observable<Intents[]> {
		return this.getCollectionWhere([`bots/${idBOT}/intents`], [{
			left: 'show',
			operator: '==',
			right: true
		}]);
	}

	getBuiltIntentsSpecificShowsDesign(collection: string, idBOT: string): Observable<Intents[]> {
		return this.getCollectionWhere([`${collection}/${idBOT}/intents`], [{
			left: 'show',
			operator: '==',
			right: true
		}]);
	}

	// Manually
	getResponseIntentsShows(collection: string, idBOT: string): Observable<Intents[]> {
		return this.getCollectionWhere([`${collection}/${idBOT}/intents`], [{
			left: 'show',
			operator: '==',
			right: true
		}, {
			left: 'smallTalk',
			operator: '==',
			right: false
		}, {
			left: 'built',
			operator: '==',
			right: false
		}]);
	}

	getIntents(idBOT: string): Observable<Intents[]> {
		return this.afs.collection<Intents>(`bots/${idBOT}/intents`).snapshotChanges().pipe(
			map(intents => {
				return intents.map(a => {
					const data = a.payload.doc.data() as Intents;
					const id = a.payload.doc.id;
					const path = a.payload.doc.ref.path;
					return {
						...data
					};
				});
			})
		);
	}

	getIntentsDesign(collection: string, idBOT: string): Observable<Intents[]> {
		return this.getCollectionWhereWithoutTime([`${collection}/${idBOT}/intents`], [{
			left: 'show',
			operator: '==',
			right: true
		}]);
	}

	updateAction(collection: string, idBot: string, actID: string, actionName: string): Promise<any> {
		return this.afs.collection(`${collection}/${idBot}/actions/`).doc(actID).ref.update({
			"name": actionName
		}).then(
			() => {
				this.loggingService.log('success');
				this.snackBar.open('success', '', {
					duration: 4000
				});
			}
		).catch(
			e => {
				this.loggingService.log(e);
				this.snackBar.open('error', '', {
					duration: 4000
				});
			});
	}


	updateActionShow(idBot: string): any {
		this.afs.collection(`bots/${idBot}/actions`).get().forEach(item => {
			return item.docs.map(m => {
				let cityRef = this.afs.collection(`bots/${idBot}/actions`).doc(m.id);

				return cityRef.ref.update({
					FlagSaved: {
						"AUDIO_OUTPUT": false,
						"SCREEN_OUTPUT": false,
						"WEB_BROWSER": false
					},
					isReco: {
						"AUDIO_OUTPUT": false,
						"SCREEN_OUTPUT": false,
						"WEB_BROWSER": false
					},

				});
			})
		});
	}

	// Update Bot TimeStamp - Uncomment this method if needed
	// updateBotTimeStamp(): any {
	//   let ind = 0;
	//   this.afs.collection(`bots`).get().forEach(item => {
	//     ind++;

	//     return item.docs.map(m => {
	//       let cityRef = this.afs.collection(`bots`).doc(m.id);
	//       return cityRef.ref.update({
	//         timeStamp: Date.now() + ind
	//       });
	//     });
	//   });
	// }

	getMessage(user: any): Observable<Message[]> {
		return this.afs.collection<Message>(`bots/${user.pageID}/getStartedMessage`)
			.snapshotChanges()
			.pipe(map(actions => {
				return actions.map(a => {
					const data = a.payload.doc.data() as Message;
					const id = a.payload.doc.id;
					const path = a.payload.doc.ref.path;
					return {
						...data
					};
				});
			}));
	}

	getMenu(idBOTmenu, menuType): Observable<Menu[]> {

		return this.afs.collection<Menu>(`bots/${idBOTmenu}/${menuType}`)
			.snapshotChanges()
			.pipe(map(actions => {
				return actions.map(a => {
					const data = a.payload.doc.data() as Menu;
					const id = a.payload.doc.id;
					const path = a.payload.doc.ref.path;
					return {
						id,
						path,
						...data
					};
				});
			}));
	}

	updateActionQrCode(idBot: string, name: string, id: string, qrCode: string) {
		return this.afs.collection(`bots/${idBot}/actions`).doc(id).ref.set({
			qrCode: qrCode,
			name: name
		}).then(
			() => {
				this.loggingService.log('success');
				this.snackBar.open('success', '', {
					duration: 4000
				});
			}
		).catch(
			e => {
				this.loggingService.log(e);
				this.snackBar.open('error', '', {
					duration: 4000
				});
			});
	}


	getTemplate(idBot: string, id: string): Observable<Templates> {

		const templatesDocuments = this.afs.doc<Templates>(`bots/${idBot}/templates/` + id + '/SCREEN_OUTPUT');
		return templatesDocuments.snapshotChanges()
			.pipe(
				map(changes => {
					const data = changes.payload.data();
					const id = changes.payload.id;
					return { id, ...data };
				}))
	}
	getTemplatewithType(idBOT: string, type: string) {
		return this.getCollectionWhere([`bots/${idBOT}/templates`], [{
			left: 'type',
			operator: '==',
			right: type
		}]);
	}

	addTemplate(idBot: string, tempID: string, templates: any): Promise<any> {
		return this.afs.collection(`bots/${idBot}/templates`).doc(tempID).set({}).then(() => {
			const templ = this.afs.collection(`bots/${idBot}/templates/`).doc(tempID)
			templ.ref.update(templates).then(
				() => {
					this.loggingService.log('success');
					/* this.snackBar.open('success', '', {duration: 4000});*/
				}
			).catch(
				e => {
					this.loggingService.log(e);
					/* this.snackBar.open('error', '', {duration: 4000});*/
				});
		});
	}

	updateTemplate(idBot: string, tempID: string, template: any): Promise<any> {
		return this.afs.collection(`bots/${idBot}/templates/`).doc(tempID).ref.update(template)
			.catch(
				e => {
					this.loggingService.log(e);
				})
			.then(
				() => {
					this.loggingService.log('success');
					// this.snackBar.open('success', '', {
					// 	duration: 4000
					// });
				}
			).catch(
				e => {
					this.loggingService.log(e);
					// this.snackBar.open('error', '', {
					// 	duration: 4000
					// });
				});
	}

	updateTemplateDesign(collection: string, idBot: string, tempID: string, template: any): Promise<any> {
		return this.afs.collection(`${collection}/${idBot}/templates/`).doc(tempID).ref.update(template)
			.catch(
				e => {
					this.loggingService.log(e);
				})
			.then(
				() => {
					this.loggingService.log('success');
					// this.snackBar.open('success', '', {
					// 	duration: 4000
					// });
				}
			).catch(
				e => {
					this.loggingService.log(e);
					// this.snackBar.open('error', '', {
					// 	duration: 4000
					// });
				});
	}

	getTemplatesDesign(collection: string, idBOT: string): Observable<Templates[]> {
		return this.afs.collection<Templates>(`${collection}/${idBOT}/templates`, ref => {
			let query = ref.orderBy('rang', 'asc');
			return query;
		})
			.snapshotChanges().pipe(
				map(template => {
					return template.map(a => {
						const data = a.payload.doc.data() as Templates;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					});
				})
			);
	}

	getLabels(idBOT: string): Observable<Labels[]> {
		return this.afs.collection<Labels>(`bots/${idBOT}/labels`)
			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data() as Labels;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					})
				),
			);
	}

	getGaActionWeb(action: any, surface: any): Observable<any[]> {
		return this.afs.collection<any>(`${action.path}/${surface}`)
			.snapshotChanges()
			.pipe(
				map(actions => {
					return actions.map(a => {
						const data = a.payload.doc.data() as any;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					}).sort((a, b) => a.index > b.index ? 1 : -1);
				})
			);
	}

	getGaActionWebResponse(action: any, surface: any): Observable<any[]> {
		return this.afs.collection<any>(`${action.path}/${surface}`)
			.snapshotChanges()
			.pipe(
				map(actions => {
					return actions.map(a => {
						const data = a.payload.doc.data() as any;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					}).sort((a, b) => a.index > b.index ? 1 : -1);
				})
			);
	}

	getGaActionWebBuilt(action: any, surface: any): Observable<any[]> {
		return this.afs.collection<any>(`${action.path}/${surface}`)
			.snapshotChanges()
			.pipe(
				map(actions => {
					return actions.map(a => {
						const data = a.payload.doc.data() as any;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					}).sort((a, b) => a.index > b.index ? 1 : -1);
				})
			);
	}

	addResponseGAActionElement(idBOT: string, actID: string, surface: string, element: any): Promise<any> {
		return this.afs.collection(`bots/${idBOT}/actions/`).doc(actID).collection(surface).add(Object.assign({}, element))
			.then(
				() => {
					this.loggingService.log('success');
					// this.snackBar.open('success', '', {
					// 	duration: 4000
					// });
				}
			).catch(
				e => {
					this.loggingService.log(e);
					// this.snackBar.open('error', '', {
					// 	duration: 4000
					// });
				});
	}

	addResponseGAActionElementDesign(collection: string, idBOT: string, actID: string, surface: string, element: any): Promise<any> {
		return this.afs.collection(`${collection}/${idBOT}/actions/`).doc(actID).collection(surface).add(Object.assign({}, element))
			.then(
				() => {
					this.loggingService.log('success');
					// this.snackBar.open('success', '', {
					// 	duration: 4000
					// });
				}
			).catch(
				e => {
					this.loggingService.log(e);
					// this.snackBar.open('error', '', {
					// 	duration: 4000
					// });
				});
	}

	addfulfilment(
		collection: string,
		idBot: string,
		actID: string,
		actionName: string,
		builtin: boolean,
		event: boolean,
		intention: boolean,
		show: boolean,
		builtTemplate: boolean,
		elements: any, // Adjust the type as needed for your specific data structure
		promptList: any, // Adjust the type as needed for your specific data structure
		parent: string | null // Assuming parent is a string or null
	): Promise<any> {
		const actionRef = this.afs.collection(`${collection}/${idBot}/actions/`).doc(actID);

		return actionRef.set({
			"parent": parent,
			"name": actionName,
			"show": show,
			"built": builtin,
			builtTemplate: builtTemplate,
			event: event,
			intention: intention,
			promptList: promptList,
			FlagSaved: {
				"AUDIO_OUTPUT": false,
				"SCREEN_OUTPUT": false,
				"WEB_BROWSER": false
			},
			isReco: {
				"AUDIO_OUTPUT": false,
				"SCREEN_OUTPUT": false,
				"WEB_BROWSER": false
			},
			help: {
				"AUDIO_OUTPUT": "",
				"SCREEN_OUTPUT": "",
				"WEB_BROWSER": "",
				"type_AUDIO_OUTPUT": "preset"
			},
			suggestions: {
				"AUDIO_OUTPUT": "",
				"SCREEN_OUTPUT": "",
				"WEB_BROWSER": ""
			},
			timeStamp: Date.now()
		})
			.then(() => {
				//TODO: add index into element, the order at which this element response will be shown @ bit's responses
				actionRef.collection('WEB_BROWSER').add(elements);
				actionRef.collection('SCREEN_OUTPUT').add(elements);
				actionRef.collection('AUDIO_OUTPUT').add(elements);
			})
			.catch(e => {
				this.loggingService.log(e);
			})
			.then(() => {
				if (parent) {
					this.afs.doc(`${parent}`).update({
						// children: firebase.firestore.FieldValue.arrayUnion(actID)
					});
				}
			})
			.then(() => {
				return actionRef.snapshotChanges().pipe(
					map(a => {
						const data = a.payload.data() as Actions;
						const id = a.payload.id;
						const path = a.payload.ref.path;
						return {
							id,
							...data
						};
					})
				);
			});
	}


	addIntentGa(collection: string, idBot: string, intentID: string, IntentName: string, userSays: any, type: any, action: any, show: any): Promise<any> {
		const IntentRef = this.afs.collection(`${collection}/${idBot}/intents/`).doc(intentID)
		return IntentRef.set({
			name: IntentName,
			type: type,
			action: action,
			dialogFlowAction: action,
			userSays: userSays,
			auto: true,
			show: show,
			timeStamp: Date.now()
		})
			.then(() => {
				return IntentRef.snapshotChanges()
					.pipe(
						map(a => {
							const data = a.payload.data() as Intents;
							const id = a.payload.id;
							const path = a.payload.ref.path;
							return {
								...data
							};
						}),
					);
			});
	}


	getActionEgalements(action: any, surface: string): Observable<any[]> {

		return this.afs.collection<any>(`${action.path}/${surface}`)
			.snapshotChanges()
			.pipe(
				map(actions => {

					return actions.map(a => {

						const data = a.payload.doc.data() as any;


						const id = a.payload.doc.id;

						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					}).sort((a, b) => a.index > b.index ? 1 : -1)
				})
			);
	}

	updateIntention(collection: string, idBOTintent: string, intentId: string, IntentName: string): Promise<any> {
		return this.afs.collection(`${collection}/${idBOTintent}/intents/`).doc(intentId).ref.update({
			"name": IntentName
		})
			.then(

				() => {
					this.loggingService.log('success');
					this.snackBar.open('success', '', {
						duration: 4000
					});
				}
			).catch(
				e => {
					this.loggingService.log(e);
					this.snackBar.open('error', '', {
						duration: 4000
					});
				});
	}

	/* Widget*/
	getWidget(collection: string, idBOT: string): Observable<Widgets[]> {
		return this.afs.collection<Widgets>(`${collection}/${idBOT}/widgets`).snapshotChanges().pipe(
			map(intents => {
				return intents.map(a => {
					const data = a.payload.doc.data() as Widgets;
					const id = a.payload.doc.id;
					const path = a.payload.doc.ref.path;
					return {
						id,

						...data
					};
				}).sort((a, b) => a.timeStamp < b.timeStamp ? 1 : -1)
			})
		);
	}

	addWidget(collection: string, idBot: string, widgetId: string, widgetName: string): Promise<any> {
		const widgetRef = this.afs.collection(`${collection}/${idBot}/widgets/`).doc(widgetId)
		return widgetRef.set({
			name: widgetName,
			timeStamp: Date.now()
		})
			.then(() => {
				return widgetRef.snapshotChanges()
					.pipe(
						map(a => {
							const data = a.payload.data() as Widgets;
							const id = a.payload.id;
							const path = a.payload.ref.path;
							return {
								id,
								...data
							};
						}),
					);
			});
	}

	deleteWidget(docpath: string): Promise<any> {
		return this.afs.doc(docpath).delete()
			.then(
				() => {
					this.snackBar.open('Delete', '', {
						duration: 4000
					});

				}
			).catch(e => {
				this.snackBar.open('error', '', {
					duration: 4000
				});
			});
	}

	delete(docpath: string): Promise<any> {
		return this.afs.doc(docpath).delete()
			.then(
				() => {
					this.snackBar.open('Delete', '', {
						duration: 4000
					});

				}
			).catch(e => {
				this.snackBar.open('error', '', {
					duration: 4000
				});
			});
	}
	updateWidget(docpath: string, element: string): Promise<any> {
		return this.afs.doc(docpath).update(element)
			.then(

				() => {
					this.loggingService.log('success');
					this.snackBar.open('success', '', {
						duration: 4000
					});
				}
			).catch(
				e => {
					this.loggingService.log(e);
					this.snackBar.open('error', '', {
						duration: 4000
					});
				});
	}

	updateWidgetName(collection: string, idBOT: string, widgetId: string, widgetName: string): Promise<any> {
		return this.afs.collection(`${collection}/${idBOT}/widgets/`).doc(widgetId).ref.update({
			"name": widgetName
		})
			.then(

				() => {
					this.loggingService.log('success');
					this.snackBar.open('success', '', {
						duration: 4000
					});
				}
			).catch(
				e => {
					this.loggingService.log(e);
					this.snackBar.open('error', '', {
						duration: 4000
					});
				});
	}

	/* ------------------------themes------------------------ */
	addTheme(idTheme: string, themeName: string, botType: string, lang: string, platform: string, userID: string): Promise<any> {
		return this.afs.collection(`themes`).doc(idTheme).set({
			botName: themeName,
			platform: platform,
			botType: botType,
			defaultBot: false,
			defaultShopbotStatus: false,
			initDialogFlow: true,
			language: lang,
			userID: userID,
			type: "theme",
			timeStamp: Date.now()

		}).then(() => {
		});
	}

	updatetheme(themeID: string, themeName: string): Promise<any> {
		return this.afs.collection(`themes/`).doc(themeID).ref.update({
			"name": themeName
		})
			.then(

				() => {
					this.loggingService.log('success');
					this.snackBar.open('success', '', {
						duration: 4000
					});
				}
			).catch(
				e => {
					this.loggingService.log(e);
					this.snackBar.open('error', '', {
						duration: 4000
					});
				});
	}

	getthemes(userID: string): Observable<any[]> {
		return this.getCollectionWhere(['themes'], [{
			left: 'userID',
			operator: '==',
			right: userID
		}]);
	}

	getthemesById(themeId: string): Observable<any[]> {
		return this.getCollectionWhere(['themes'], [{
			left: 'themeId',
			operator: '==',
			right: themeId
		}]);
	}

	getUsersbots(userID: string): Observable<any[]> {
		return this.getCollectionWhere(['bots'], [{
			left: 'userID',
			operator: '==',
			right: userID
		}]);
	}

	getStoreBots(storeId: string, userID: string): Observable<any[]> {
		return this.getCollectionWhere(['bots'], [{
			left: 'cmsShop',
			operator: '==',
			right: storeId
		},
		{
			left: 'userID',
			operator: '==',
			right: userID
		},
		]);
	}

	getAllbots(): Observable<any[]> {
		return this.afs.collection<any>(`bots`)
			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data();

						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							path,
							id,
							...data
						};

					}).sort((a, b) => a.timeStamp < b.timeStamp ? 1 : -1)
				),
			);
	}


	getAllThemes(): Observable<any[]> {
		return this.afs.collection<any>(`themes`)
			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data();

						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							path,
							id,
							...data
						};

					}).sort((a, b) => a.timeStamp < b.timeStamp ? 1 : -1)
				),
			);
	}

	// get cataogs list
	getUserscatalogs(userID: string): Observable<any[]> {
		return this.getCollectionWhere(['catalogs'], [{
			left: 'userID',
			operator: '==',
			right: userID
		}]);
	}

	getUsersOrders(userID: string): Observable<any[]> {
		return this.getCollectionWhere(['orders'], [{
			left: 'userID',
			operator: '==',
			right: userID
		}]);
	}

	addResponseAlexaActionElementDesign(collection: string, idBOT: string, actID: string, surface: string, element: any): Promise<any> {
		return this.afs.collection(`${collection}/${idBOT}/actions/`).doc(actID).collection(surface).add(Object.assign({}, element))
			.then(
				() => {
				}
			).catch(
				e => {
				}
			);
	}

	getAllcatalogs(): Observable<any[]> {
		return this.afs.collection<any>(`catalogs`)

			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data() as Catalogs;

						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							path,
							...data
						};

					}).sort((a, b) => a.timeStamp < b.timeStamp ? 1 : -1)
				),
			);
	}

	// get products
	getAllproducts(idCatalog: string): Observable<any[]> {
		return this.afs.collection<any>(`catalogs/${idCatalog}/products`)
			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data() as Products;

						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							...data
						};

					})
				),
			);
	}
	// get options
	getAlloptions(idCatalog: string): Observable<any[]> {
		return this.afs.collection<any>(`catalogs/${idCatalog}/options`)
			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data() as Options;

						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							...data
						};

					})
				),
			);
	}

	// getAllvariants(idCatalog:string): Observable<any[]> {
	// 	return this.getCollectionWhereWithoutTime([(`catalogs/${idCatalog}/options`)], [, {
	// 		left: 'usedforvariants',
	// 		operator: '==',
	// 		right: true
	// 	}]);
	// }

	getOptionsUsedforVariants(idCatalog: string): Observable<any[]> {
		return this.getCollectionWhereWithoutTime([(`catalogs/${idCatalog}/options`)], [{
			left: 'usedforvariants',
			operator: '==',
			right: true
		}]);
	}

	getOptions(idCatalog: string): Observable<any[]> {
		return this.getCollectionWhereWithoutTime([(`catalogs/${idCatalog}/options`)], [{
			left: 'usedforvariants',
			operator: '==',
			right: false
		}]);
	}

	getAlloptionsid(idCatalog: string): Observable<any[]> {

		return this.afs.collection<Options>(`catalogs/${idCatalog}/options`).snapshotChanges().pipe(
			map(intents => {
				return intents.map(a => {
					const data = a.payload.doc.data() as Options;
					const id = a.payload.doc.id;
					const path = a.payload.doc.ref.path;
					return {
						id,
						...data
					};
				});
			})
		);
	}
	//New
	getCollectionWhereOrderByrang(pathArray: string[], conditions: Condition[]): Observable<any[]> {
		const coPath = pathArray.join('/');
		return this.afs.collection<any>(coPath,
			ref => {
				const cnd0 = conditions.pop();
				if (!this.tools.isUndefined(cnd0)) {
					let query = ref.where(cnd0?.left, cnd0?.operator, cnd0?.right).orderBy('rang', 'asc');
					conditions.map(({
						left,
						operator,
						right
					}: Condition) => {
						query = query.where(left, operator, right);
					});
					return query;
				} else {
					return ref;
				}
			}).snapshotChanges().pipe(
				map(actions => {
					return actions.map(a => {
						const data = a.payload.doc.data() as any;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					});
				}));
	}

	getTemplatesWhereCondition(collection: string, idBOT: string, condition: string): Observable<Templates[]> {
		return this.getCollectionWhereOrderByrang([`${collection}/${idBOT}/templates/`], [{
			left: 'type',
			operator: '==',
			right: condition
		}])

	}

	getGaTemplateSurface(template: any, surface: string): Observable<any[]> {
		return this.afs.collection<any>(`${template?.path}/${surface}`)
			.snapshotChanges()
			.pipe(
				map(templates => {
					return templates.map(a => {
						const data = a.payload.doc.data() as any;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					})
				})
			);
	}
	getGaTemplateSurfaces(path: string, surface: string): Observable<any[]> {
		return this.afs.collection<any>(`${path}/${surface}`)
			.snapshotChanges()
			.pipe(
				map(templates => {
					return templates.map(a => {
						const data = a.payload.doc.data() as any;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					})
				})
			);
	}
	addTemplateMSElementDesign(collection: string, idBOT: string, tempId: string, element: any): Promise<any> {
		return this.afs.collection(`${collection}/${idBOT}/templates/`).doc(tempId).collection('elements').add(Object.assign({}, element))
			.then(
				() => {
					this.loggingService.log('success');
				}
			).catch(
				e => {
					this.loggingService.log(e);
				});

	}
	getTemplates(idBOT): Observable<Templates[]> {
		return this.afs.collection<Templates>(`bots/${idBOT}/templates`, ref => {

			let query = ref.orderBy('rang', 'asc');

			return query;

		})
			.snapshotChanges().pipe(
				map(template => {
					return template.map(a => {
						const data = a.payload.doc.data() as Templates;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					});
				})
			);
	}

	updateTemplateNew(path: string, template: any): Promise<any> {
		return this.afs.doc(path).ref.update(template)
			.catch(
				e => {
					this.loggingService.log(e);
				})
			.then(() => {
				this.loggingService.log('success');
				this.snackBar.open('success', '', {
					duration: 4000
				});
			}
			).catch(
				e => {
					this.loggingService.log(e);
					// this.snackBar.open('error', '', {
					// 	duration: 4000
					// });
				});
	}

	addTemplateGAElementDesign(collection: string, idBOT: string, tempId: string, surface: string, element: any): Promise<any> {
		return this.afs.collection(`${collection}/${idBOT}/templates/`).doc(tempId).collection(surface).add(Object.assign({}, element))
			.then(
				() => {
					this.loggingService.log('success');
				}
			).catch(
				e => {
					this.loggingService.log(e);
				});

	}

	//Confirmation
	getGAconfirmationGA(confirmationPath: string): Observable<any[]> {

		return this.afs.collection<any>(`${confirmationPath}`)
			.snapshotChanges()
			.pipe(
				map(actions => {

					return actions.map(a => {

						const data = a.payload.doc.data() as any;


						const id = a.payload.doc.id;

						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					}).sort((a, b) => a.index > b.index ? 1 : -1)
				})
			);
	}


	updateOptions(docpath: string, element: string): Promise<any> {
		return this.afs.doc(docpath).update(element)
			.then(

				() => {
					this.loggingService.log('success');
					this.snackBar.open('success', '', {
						duration: 4000
					});
				}
			).catch(
				e => {
					this.loggingService.log(e);
					this.snackBar.open('error', '', {
						duration: 4000
					});
				});
	}

	updateProducts(docpath: string, element: string): Promise<any> {
		return this.afs.doc(docpath).update(element)
			.then(

				() => {
					this.loggingService.log('success');
					this.snackBar.open('success', '', {
						duration: 4000
					});
				}
			).catch(
				e => {
					this.loggingService.log(e);
					this.snackBar.open('error', '', {
						duration: 4000
					});
				});
	}

	getOption(idCatalog: string, idOpt: string): Observable<any[]> {

		return this.afs.collection<any>(`catalogs/${idCatalog}/options/${idOpt}`)
			.snapshotChanges()
			.pipe(
				map(actions => {

					return actions.map(a => {

						const data = a.payload.doc.data() as any;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					}).sort((a, b) => a.index > b.index ? 1 : -1)
				})
			);
	}

	addOptions(idCatalog: string, element: string): Promise<any> {
		return this.afs.collection(`catalogs/${idCatalog}/options/` + 'testtest').add(element)
			.then(
				() => {
				}
			).catch(
				e => {

					this.loggingService.log(e);
					this.snackBar.open('error', '', {
						duration: 4000
					});
				});
	}

	getthemesWherePlatform(paltform: string): Observable<any[]> {
		return this.getCollectionWhere([`themes`], [{
			left: 'platform',
			operator: '==',
			right: paltform
		}])
	}

	getOrdersWhereUserID(userID: string): Observable<Orders[]> {
		return this.getCollectionWhere([`orders`], [{
			left: 'userID',
			operator: '==',
			right: userID
		}])
	}

	getWoocommerceOrdersWhereUserID(userID: string, cmsShop: string): Observable<Orders[]> {
		return this.getCollectionWhereWithoutTime([`woocommerceOrders/${cmsShop}/orders`], [{
			left: 'userID',
			operator: '==',
			right: userID
		}]);

	}

	getWoocommerceDraftOrdersWhereUserID(userID: string, cmsShop: string): Observable<Orders[]> {
		return this.getCollectionWhereWithoutTime([`woocommerceDraftOrders/${cmsShop}/orders`], [{
			left: 'userID',
			operator: '==',
			right: userID
		}]);

	}

	getDraftOrdersWhereUserID(userID: string): Observable<DraftOrders[]> {
		return this.getCollectionWhere([`draftOrders`], [{
			left: 'userID',
			operator: '==',
			right: userID
		}])
	}

	addCategory(idCatalog: string, actID: string, categoryName: string, elements: any): Promise<any> {
		const actionRef = this.afs.collection(`catalogs/${idCatalog}/categories/`).doc(actID)
		return actionRef.set({
			"name": categoryName,
			timeStamp: Date.now()
		})
			.then(() => {
				return actionRef.snapshotChanges()
					.pipe(
						map(a => {
							const data = a.payload.data() as Categories;
							const id = a.payload.id;
							const path = a.payload.ref.path;
							return {
								id,
								...data
							};
						}),
					);
			})
	}

	getCategories(idCatalog: string): Observable<any[]> {
		return this.afs.collection<any>(`catalogs/${idCatalog}/categories`)
			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data() as Categories;

						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							...data
						};

					})
				),
			);
	}

	getAccessibleCategories(idCatalog: string): Observable<Categories[]> {
		return this.getCollectionWhereWithoutTime([`catalogs/${idCatalog}/categories`], [{
			left: 'show',
			operator: '==',
			right: true
		}]);

	}

	findIntentwithPAYLAOD(path: string, payload: string): Observable<Categories[]> {
		return this.getCollectionWhereWithoutTime([`${path}`], [{
			left: 'allpayloads',
			operator: 'array-contains',
			right: payload
		}]);

	}

	getuserID(userID: string): Observable<any[]> {

		return this.afs.collection<any>(`users`)
			.snapshotChanges()
			.pipe(
				map(actions => {

					return actions.map(a => {

						const data = a.payload.doc.data() as any;


						const id = a.payload.doc.id;

						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					}).find(x => x.id == userID)
				})
			);
	}

	getOrdersbyId(idOrder: string): Observable<any[]> {
		return this.afs.collection<any>(`orders`)
			.snapshotChanges()
			.pipe(
				map(actions => {

					return actions.map(a => {

						const data = a.payload.doc.data() as any;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					}).find(x => x.id == idOrder)
				})
			);
	}

	getcatalogbyshopID(shop_ID: string): Observable<any[]> {
		return this.afs.collection<any>(`catalogs`)
			.snapshotChanges()
			.pipe(
				map(actions => {

					return actions.map(a => {

						const data = a.payload.doc.data() as any;


						const id = a.payload.doc.id;

						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					}).find(x => x.id == shop_ID)
				})
			);
	}

	getActionPromptList(collection: string, idBOT: string): Observable<Actions[]> {

		return this.getCollectionWhereWithoutTime([`${collection}/${idBOT}/actions`], [{
			left: 'promptList',
			operator: '==',
			right: true
		}]);
	}

	updatesettingscatalog(docpath: string, element: any): Promise<any> {
		return this.afs.doc(docpath).update(element)
			.then(

				() => {
					this.loggingService.log('success');
					this.snackBar.open('success', '', {
						duration: 4000
					});
				}
			).catch(
				e => {
					this.loggingService.log(e);
					this.snackBar.open('error', '', {
						duration: 4000
					});
				});
	}

	getVaraint(collection: string, idCatalog: string, idProduit: string, key: string, option: string): Observable<Catalogs[]> {
		return this.getCollectionWhereWithoutTime([(`${collection}/${idCatalog}/products/${idProduit}/varaints/`)], [{
			left: 'facets.' + key,
			operator: '==',
			right: option
		}, {
			left: 'show',
			operator: '==',
			right: true
		}]);
	}

	getnoVaraint(collection: string, idCatalog: string, idProduit: string): Observable<Catalogs[]> {
		return this.getCollectionWhereWithoutTime([(`${collection}/${idCatalog}/products/${idProduit}/varaints/`)], [{
			left: 'show',
			operator: '==',
			right: true
		}]);
	}

	getSmallTalkIntents(collection: string, idBOT: string): Observable<Intents[]> {

		return this.getCollectionWhere([`${collection}/${idBOT}/intents`], [{
			left: 'show',
			operator: '==',
			right: true
		}, {
			left: 'smallTalk',
			operator: '==',
			right: true
		}])
	}

	getuserList(): Observable<any[]> {

		return this.afs.collection<any>(`users`).snapshotChanges().pipe(
			map(users => {
				return users.map(a => {
					const data = a.payload.doc.data() as any;
					const id = a.payload.doc.id;
					const path = a.payload.doc.ref.path;
					return {
						id,
						path,
						...data
					};
				})
			})
		);
	}
	getComplaintsList(): Observable<any[]> {

		return this.afs.collection<any>(`complaints`).snapshotChanges().pipe(
			map(complaints => {
				return complaints.map(c => {
					const data = c.payload.doc.data() as any;
					const id = c.payload.doc.id;
					const path = c.payload.doc.ref.path;
					return {
						id,
						path,
						...data
					};
				})
			})
		);
	}

	getshopsPlatform(platform: string): Observable<any[]> {

		return this.afs.collection<any>(`${platform}`).snapshotChanges().pipe(
			map(shops => {
				return shops.map(a => {
					const data = a.payload.doc.data() as any;
					const id = a.payload.doc.id;
					const path = a.payload.doc.ref.path;
					return {
						id,
						path,
						...data
					};
				})
			})
		);
	}

	getUserShops(path: string): Observable<any[]> {
		return this.afs.collection<any>(`${path}`)
			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data() as any;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};

					})
				),
			);
	}

	getDraftOrdersWithpath(path: string): Observable<Orders[]> {

		return this.afs.collection<any>(`${path}`)
			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data() as Orders;
						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							...data
						};

					})
				),
			);
	}


	getUserOrders(path: string, customer: any): Observable<any[]> {
		this.loggingService.log('path,customer', path, customer)
		return this.getCollectionWhereWithoutTime([`${path}`], [{
			left: 'customer.id',
			operator: '==',
			right: customer.id
		}]);
	}
	getUser(id: string): Observable<any> {
		return this.afs.collection<any>(`users`).doc(id).valueChanges().pipe();
	  }
	getAllpreBuiltAgent(): Observable<any[]> {

		return this.afs.collection<any>(`/general/prebuiltAgents/dialogflow`)
			.snapshotChanges()
			.pipe(
				map(actions =>
					actions.map(a => {
						const data = a.payload.doc.data();

						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};

					})
				),
			);
	}

	getPackProduct(productId: string): Observable<any[]> {
		return this.afs.collection<any>(`general/packs/liste_packs/`)
			.snapshotChanges()
			.pipe(
				map(actions => {
					return actions.map(a => {

						const data = a.payload.doc.data() as any;


						const id = a.payload.doc.id;

						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};
					}).find(x => x.id == productId)
				})
			);
	}

	async addIntentPrebuilt(path: string, body: any) {
		const IntentRef = this.afs.doc(path);
		await IntentRef.set(body, { merge: true }).then(() => {
			return IntentRef.snapshotChanges().pipe(
				map(a => {
					const data = a.payload.data() as Intents;
					const id = a.payload.id;
					const path = a.payload.ref.path;
					return {
						...data
					};
				})
			);
		});
	}

	getResponseStoresofuser(platform: string, userID: string): Observable<any[]> {
		return this.getCollectionWhereWithoutTime([platform], [
			{
				left: 'userID',
				operator: '==',
				right: userID
			}
		]);
	}

	getCatalogsofstore(path: string): Observable<any[]> {
		return this.afs.collection<any>(path).snapshotChanges().pipe(
			map(actions => {
				return actions.map(a => {
					const data = a.payload.doc.data() as any;
					const id = a.payload.doc.id;
					const path = a.payload.doc.ref.path;
					return {
						id,
						path,
						...data
					};
				});
			})
		);
	}

	getDataBetweenTwoDates(
		path: string,
		startDate: any,
		endDate: any,
		data: any
	): Observable<any> {
		this.loggingService.log(", startDate", startDate, ", endDate", endDate , 'data' , data ,'path' , path ); 
		this.loggingService.log(typeof startDate ,  typeof endDate , typeof data  );
		return this.getCollectionWhereWithoutTime([path], [
			{
				left: data,
				operator: '>=',
				right: startDate
			},
			{
				left: data,
				operator: '<=',
				right: endDate
			}
		]);
	}
	
	getStartDateIsDate(path: string, startDate: any, start: any): Observable<any[]> {
		return this.getCollectionWhereWithoutTime([path], [
			{
				left: startDate,
				operator: '==',
				right: start
			}
		]);
	}

	getCollectionWhenChange(path): Observable<any>
	{
	   return this.afs.collection(path).valueChanges()
	}
   
	getdurationBetweenTwoDates(
		path: string,
		startDate: any,
		endDate: any,
		data: any
	): Observable<any> {
		this.loggingService.log(", startDate", startDate, ", endDate", endDate , 'data' , data); 
		this.loggingService.log(typeof startDate ,  typeof endDate , typeof data  );

		
		return this.getCollectionWhereWithoutTime([path], [
			{
				left: data,
				operator: '>=',
				right: startDate
			},
			{
				left: data,
				operator: '<=',
				right: endDate
			}
		]);
	}

	nbTotalConversation(
		pathArray: string[],
		key: string,
		startDate: Date,
		endDate: Date
	): Observable<any[]> {
		const bb = `nbConvPerDay[${key}]`;
		this.loggingService.log("bb", bb);
		const coPath = pathArray.join('/');
		return this.afs.collection<any>(coPath, ref => {
			let query = ref
				.where(`${bb}`, '>=', startDate)
				.where(`${bb}`, '<=', endDate);
			return query;
		}).snapshotChanges().pipe(
			map(actions => {
				return actions.map(a => {
					const data = a.payload.doc.data() as any;
					const id = a.payload.doc.id;
					const path = a.payload.doc.ref.path;
					return {
						id,
						path,
						...data
					};
				});
			})
		);
	}

	getOldUsers(path: string, startDate: any, data: string): Observable<any[]> {
		return this.getCollectionWhereWithoutTime([path], [
			{
				left: data,
				operator: '>=',
				right: startDate
			}
		]);
	}


	checkIfDocumentExists(collectionName: string, fieldName: string, operator: WhereFilterOp, value: any): Observable<boolean> {
		this.loggingService.log('test here ', collectionName, fieldName, operator, value)
		return this.afs.collection(collectionName, ref => ref.where(fieldName, operator, value))
			.valueChanges()
			.pipe(
				take(1),
				map(docs => docs.length > 0)
			)

	}
	async saveIntegrationDfMessengenShopify(fileData, idBot, bot) {
		//  location of the file 
		const fileRef = this.storage.ref(`uploads//bots//${idBot}//ScriptWidget.js`);
		// writting javascript file and uploading it directly to firebase storage    
		fileRef.putString(fileData, 'raw', { contentType: 'application/javascript' })
			//   detect the change 
			.snapshotChanges().pipe(
				//    when the file is created and the url is generated, call the api for shopify integration
				finalize(async () => {
					var body = {

						"shop": bot.cmsShop,
						"scriptTagID": bot.scriptTagID,
						"scriptTagUrl": this.urlUpload

					}
					// calling the api to update integration Url in shopify and make the change on the web page page  
					// await this.RAS.postApi(`${environment.shopifyProdBaseURL[bot.botType]}/script-tag/update`, body).subscribe(async res => {
					// 	this.loggingService.log(res)
					// 	if (res.status === "success")
					// 	{
					// 		this.snackBar.open('url integration created succefully' + this.urlUpload, '', { duration: 4000 });
					// 	}
					// 	else 
					// 	{
					// 		this.loggingService.log(res)
					// 		this.loggingService.log(this.urlUpload)
					// 		this.snackBar.open('This may take some few minutes, Please try again  later!', '', { duration: 4000 });
					// 	}
					// })

				})

				// getting the file url location 
			).subscribe(() => fileRef.getDownloadURL().subscribe(urlUpload => {
				this.urlUpload = urlUpload
			}))

	}
	async saveIntegrationDfMessengerForCustom(fileData, idBot, bot) {

		//  location of the file 
		const fileRef = this.storage.ref(`uploads//bots//${idBot}//dialogflowMessengerScriptForCustom.js`);
		// writting javascript file and uploading it directly to firebase storage    
		fileRef.putString(fileData, 'raw', { contentType: 'application/javascript' })
			//   detect the change 
			.snapshotChanges().pipe(
				//    when the file is created and the url is generated, call the api for shopify integration
				finalize(async () => {
					var body = {

						"shop": bot.cmsShop,
						"scriptTagID": bot.scriptTagID,
						"scriptTagUrl": this.urlUpload

					}
					// calling the api to update integration Url in shopify and make the change on the web page page  
					// await this.RAS.postApi(`${environment.shopifyProdBaseURL[bot.botType]}/script-tag/update`, body).subscribe(async res => {
					// if (res.status === "success")
					// {
					// 	this.snackBar.open('url integration created succefully' + this.urlUpload, '', { duration: 4000 });
					// }
					// else 
					// {
					// 	this.loggingService.log(res)
					// 	this.loggingService.log(this.urlUpload)
					// 	this.snackBar.open('This may take some few minutes, Please try again  later!', '', { duration: 4000 });
					// } 
					// })

				})

				// getting the file url location 
			).subscribe(() => fileRef.getDownloadURL().subscribe(urlUpload => {
				let element = {
					scriptUrl: urlUpload
				}
				return this.afs.doc(`bots/${bot.id}`).update(element)

					// this.afs.doc(docpath).update(element)
					.then(

				).catch(
					e => {

						this.loggingService.log(e);
						this.snackBar.open('error', '', {
							duration: 4000
						});
					});

			}))

	}
	updateFollowUp(collection: string, idBot: string, actID: string, actionName: string): Promise<any> {
		return this.afs.collection(`${collection}/${idBot}/FollowUpMessages/`).doc(actID).ref.update({
			"name": actionName
		}).then(
			() => {
				this.loggingService.log('success');
				this.snackBar.open('success', '', {
					duration: 4000
				});
			}
		).catch(
			e => {
				this.loggingService.log(e);
				this.snackBar.open('error', '', {
					duration: 4000
				});
			});
	}
	getAllFollowUpMessages(collection, idBot): Observable<any[]> {
		return this.afs.collection<any>(`${collection}/${idBot}/FollowUpMessages`).snapshotChanges().pipe(
			map(actions => {
				return actions.map(a => {
					const data = a.payload.doc.data() as any;
					const id = a.payload.doc.id;
					const path = a.payload.doc.ref.path;
					return {
						id,
						path,
						...data
					};
				});
			})
		);
	}

    getAllMarketingMessages(collection, idBot): Observable<any[]> {
		return this.afs.collection<any>(`${collection}/${idBot}/MarketingMessages`).snapshotChanges().pipe(
			map(actions => {
				return actions.map(a => {
					const data = a.payload.doc.data() as any;
					const id = a.payload.doc.id;
					const path = a.payload.doc.ref.path;
					return {
						id,
						path,
						...data
					};
				});
			})
		);
	} 

	updateIntent(docpath, element): Promise<any> {
		return this.afs.doc(docpath).update(element)
			.then(

				() => {
					// this.loggingService.log('success');
					// this.snackBar.open('success', '', {
					// 	duration: 4000
					// });
				}
			).catch(
				e => {
					// this.loggingService.log(e);
					// this.snackBar.open('error', '', {
					// 	duration: 4000
					// });
				});
	}
	getAlldocuments(path): Observable<any[]> {
		return this.afs.collection<any>(path)
			.snapshotChanges()
			.pipe(
				map(documents =>
					documents.map(a => {
						const data = a.payload.doc.data();

						const id = a.payload.doc.id;
						const path = a.payload.doc.ref.path;
						return {
							id,
							path,
							...data
						};

				}).sort((a, b) => a.timeStamp < b.timeStamp ? 1 : -1)
			),
		);
}
 getCollection(path): Observable<any>
 {
	return this.afs.collection(path).valueChanges()
 }

	addNewDoc(path, docName, body) {

		const docRef = this.afs.collection(path).doc(docName)
		this.loggingService.log('body', body)
		this.loggingService.log('docRef',docRef)
		return docRef.set(body, { merge: true })
			.then(() => {
				return docRef.snapshotChanges()
					.pipe(
						map(a => {
							const data = a.payload.data() as Intents;
							const id = a.payload.id;
							const path = a.payload.ref.path;
							return {
								...data
							};
						}),
					);
			});

	}
}
